import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';

export default function Navigation() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 100);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navBackground = scrolled
    ? 'bg-trueBlack/90 backdrop-blur-md border-b border-border-subtle'
    : 'bg-transparent backdrop-blur-md';

  const linkClasses = ({ isActive }: { isActive: boolean }) =>
    `text-sm font-mono uppercase tracking-wider transition-colors duration-200 ${
      isActive
        ? 'text-neonOrange border-b-2 border-neonOrange'
        : 'text-offWhite hover:text-neonOrange'
    }`;

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 h-20 px-4 md:px-8 flex items-center justify-between gap-6 transition-all duration-300 ${navBackground}`}
      role="navigation"
      aria-label="Main navigation"
    >
      <div className="flex items-center gap-4">
        <div className="text-xl font-bold font-display tracking-tighter">
          JMD
        </div>
        <div className="hidden text-xs uppercase tracking-[0.2em] text-text-muted md:block">
          Creative direction / identity systems
        </div>
      </div>

      <div className="flex items-center gap-4 md:gap-8">
        <NavLink to="/" className={linkClasses}>
          Home
        </NavLink>
        <NavLink to="/projects" className={linkClasses}>
          Projects
        </NavLink>
        <NavLink to="/contact" className={linkClasses}>
          Contact
        </NavLink>
      </div>
    </nav>
  );
}
